<template>
  <Dialog
    v-model:visible="showModal"
    :modal="true"
    :class="{
      'w-full lg:w-5/6 h-5/6': !size,
      'w-full lg:w-2/3 h-auto lg:h-1/3': size == 'sm',
      'w-full lg:w-96 h-auto': size == 'xs',
      'w-full lg:w-1/3 h-auto lg:h-2/3': size == 'md',
      'w-screen h-screen': size == 'xxl',
    }"
    class="flex bg-white shadow rounded-xl"
  >
    <template #header>
      <div class="px-2 lg:px-6 w-full text-gray-900">
        <slot name="header"></slot>
      </div>
    </template>

    <div class="px-2 lg:px-4 py-2 border-t border-b border-gray-200 bg-gray-50 h-full">
      <slot name="content"></slot>
    </div>

    <template #footer>
      <div class="px-3 lg:px-6 pt-4 w-full text-right">
        <slot name="footer"></slot>
      </div>
    </template>
    <!-- ???? -->
    <div v-if="msgGuideStep >= 701 && msgGuideStep <= 735" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);z-index: 9999;"></div>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";

export default {
  name: "ChangePlanDialog",
  components: {
    Dialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    size: String,
    msgGuideStep: Number
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function (value) {
        this.$emit("update:show", value);
      },
    },
  },
};
</script>

<style lang="postcss" scope>
.p-dialog-content {
  @apply flex-grow;
}
</style>